export const safetyNetContent = {
  title: "An Insurance Policy for Your Advertising Budget",
  paragraphs: [
    "We don't ask for extra ad budget. You are already paying Google and Facebook for traffic.",
    "FractoLabs is the Safety Net installed under your existing marketing to make sure zero leads slip through the cracks while you're driving, up on a roof, or off the clock.",
  ],
}
